<div class="mt-2">
  <ag-shr-editor-toolbar
    [title]="caption"
    [type]="type"
    [isEditVisible]="hasPermissionsToEdit"
    [agentDbId]="agentDbId"
    (clickEdit)="showEditorModal()"
  ></ag-shr-editor-toolbar>

  <div class="row" [ngClass]="type === LayoutGridType.short ? '' : 'my-2 px-3'">
    <div class="text-start" [ngClass]="type === LayoutGridType.short ? 'col-12' : 'col-3'"><b>Shirt Size:</b></div>
    <div
      [ngClass]="type === LayoutGridType.short ? 'col-12 mb-3' : 'col-3'"
      *var="funStaffFormDetails?.[AgentKeys.tShirtSizes]?.[TShirtSizesKeys?.genderTShirtSize] as genderTShirtSize"
    >
      {{ genderTShirtSize | tShirtSize | async }}
    </div>

    <div class="text-start" [ngClass]="type === LayoutGridType.short ? 'col-12' : 'col-3'"><b>Hobbies:</b></div>
    <div [ngClass]="type === LayoutGridType.short ? 'col-12 mb-3' : 'col-3'">
      {{ funStaffFormDetails?.[AgentKeys.hobbies] }}
    </div>
  </div>

  <div class="row" [ngClass]="type === LayoutGridType.short ? '' : 'my-2 px-3'">
    <div class="text-start" [ngClass]="type === LayoutGridType.short ? 'col-12' : 'col-3'"><b>T-Shirt Size:</b></div>
    <div
      [ngClass]="type === LayoutGridType.short ? 'col-12 mb-3' : 'col-3'"
      *var="funStaffFormDetails?.[AgentKeys.tShirtSizes]?.[TShirtSizesKeys?.unisextShirtSize] as unisextShirtSize"
    >
      {{ unisextShirtSize | tShirtSize | async }}
    </div>

    <div class="text-start" [ngClass]="type === LayoutGridType.short ? 'col-12' : 'col-3'">
      <b>Favorite Destination:</b>
    </div>
    <div [ngClass]="type === LayoutGridType.short ? 'col-12 mb-3' : 'col-3'">
      {{ funStaffFormDetails?.[AgentKeys.favorite_destination] }}
    </div>
  </div>

  <div class="row" [ngClass]="type === LayoutGridType.short ? '' : 'my-2 px-3'">
    <div class="text-start" [ngClass]="type === LayoutGridType.short ? 'col-12' : 'col-3'"><b>Shoe Size:</b></div>
    <div [ngClass]="type === LayoutGridType.short ? 'col-12' : 'col-3'">
      {{ funStaffFormDetails?.[AgentKeys.shoe_size] }}
    </div>
  </div>
</div>

<ag-shr-modal-window
  [width]="isFullWidth ? '100vw' : '50vw'"
  [height]="isFullWidth ? '100vh' : 'auto'"
  #sizeModalRef
  [title]="caption"
  [inProgress]="inProgress()"
  (onSaveClick)="saveAgentUpdates()"
  (onPopupClose)="handleClosePopup($event)"
>
  <dx-form
    #sizeFormRef
    class="mt-2 sizes-modal-form"
    [formData]="funStaffFormDetails"
    (onInitialized)="onFormInitialized($event)"
    [colCountByScreen]="colCountByModalSig()"
    labelMode="floating"
  >
    <dxi-item cssClass="sizes-modal-card" [colSpan]="1">
      <div *dxTemplate>
        <ag-shr-t-shirt-sizes-form
          [formData]="funStaffFormDetails?.[AgentKeys.tShirtSizes]"
          [tShirtCategoryVisible]="false"
          [validationGroup]="shirtSeizesFormValidationGroup"
          [tShirtNote]="'Note: T-shirts are unisex.'"
          [dropdownsAlwaysVisible]="true"
          [isReverseOrder]="true"
          layout="vertical"
          [sectionNotePadding]="false"
        ></ag-shr-t-shirt-sizes-form>
      </div>
    </dxi-item>
    <dxi-item itemType="group" [colSpan]="2" cssClass="sizes-modal-card sizes-modal-card--left">
      <dxi-item [dataField]="AgentKeys.shoe_size">
        <dxo-label [text]="'Shoe Size'"></dxo-label>
      </dxi-item>

      <dxi-item [dataField]="AgentKeys.favorite_destination">
        <dxo-label [text]="'Favorite Destination'"></dxo-label>
      </dxi-item>

      <dxi-item [dataField]="AgentKeys.hobbies" editorType="dxTextArea" [editorOptions]="{ height: '114px' }">
        <dxo-label [text]="'Hobbies'"></dxo-label>
      </dxi-item>
    </dxi-item>
  </dx-form>
</ag-shr-modal-window>
